<template>
  <div>
    <div class="card p-2">
      <TitleButton
        :showBtn="true"
        title="Pay Bill"
        :showAddNew="false"
        @onClickCloseButton="navigateToListPage"
      />

      <div class="row gy-1 pt-75 bg-blue-light rounded-8 mt-1 pb-2">
        <div class="col-12 col-sm-6 col-md-4 col-lg-3">

          <div class="d-flex align-items-center justify-content-between filter-label">
            <label for="colFormLabel" class="col-form-label">Party: </label>
            <span v-if="!routeContactId" class="filter-search-icon cursor-pointer" @click="onOpenContactSearchModal">
                  <i class="fas fa-search"></i>
              </span>
          </div>
          <input
              v-if="routeContactId"
              type="text"
              class="form-control invoice-edit-input"
              placeholder=""
              v-model="singleContactInfo.name"
              readonly
          />

          <AsyncSelect
              v-else
              placeholder="Party Name, ID, Mobile No"
              v-model="selectedContact"
              :api-service="fetchContactProfiles"
              :additional-query="{ with_mobile: 1, roles: 'supplier' }"
              :format-label="formatPatientLabel"
              :option-selected="onchangeContact"
          />
        </div>

        <div class="col-12 col-sm-6 col-md-4 col-lg-3">
          <label for="colFormLabel" class="col-form-label">Payment Date</label>
          <input
            class="form-control invoice-edit-input date-picker flatpickr-input flatpickr-mobile"
            tabindex="1"
            type="date"
            placeholder=""
            v-model="formData.payment_date"
          />
        </div>

        <div class="col-12 col-sm-6 col-md-4 col-lg-3">
          <label for="colFormLabel" class="col-xl-3 col-form-label"
            >Paid From</label
          >
          <v-select
            v-model="formData.account_head_id"
            placeholder="Select Cash & Bank Account"
            class="w-100"
            :options="accountHeads"
            label="name"
            :reduce="(name) => name.id"
          />
        </div>
        <div class="col-12 col-sm-6 col-md-4 col-lg-3">
          <label for="colFormLabel" class="col-form-label">Advance Amount</label>
          <div class="input-group">
            <input
                v-model="formData.total_paid_amount"
                type="number"
                class="form-control"
                placeholder=""
            />
          </div>
        </div>

        <div class="col-12 col-sm-6 col-md-4 col-lg-3">
          <label for="colFormLabel" class="col-form-label">Payment Ref</label>
          <input
            type="hidden"
            class="form-control invoice-edit-input date-picker flatpickr-input"
            readonly="readonly"
          />
          <div class="input-group input-group-merge invoice-edit-input-group">
            <div class="input-group-text">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="14"
                height="14"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
                class="feather feather-hash"
              >
                <line x1="4" y1="9" x2="20" y2="9"></line>
                <line x1="4" y1="15" x2="20" y2="15"></line>
                <line x1="10" y1="3" x2="8" y2="21"></line>
                <line x1="16" y1="3" x2="14" y2="21"></line>
              </svg>
            </div>
            <input
              v-model="formData.payment_reference"
              type="text"
              class="form-control invoice-edit-input"
              placeholder=""
            />
          </div>
        </div>

        <div class="col-12 col-sm-6 col-md-4 col-lg-3">
          <label for="colFormLabel" class="col-form-label">P.Ref Date</label>
          <input
            class="form-control invoice-edit-input date-picker flatpickr-input flatpickr-mobile"
            tabindex="1"
            type="date"
            placeholder=""
            v-model="formData.payment_reference_date"
          />
        </div>

        <div class="col-12 col-sm-6 col-md-4 col-lg-3">
          <label for="colFormLabel" class="col-form-label">Balance</label>
          <input
            type="hidden"
            class="form-control invoice-edit-input date-picker flatpickr-input"
            readonly="readonly"
          />
          <div class="input-group input-group-merge invoice-edit-input-group">
            <input
              v-model="balance"
              readonly
              type="text"
              class="form-control invoice-edit-input"
              placeholder=""
            />
          </div>
        </div>
        <div class="col-12 col-sm-6 col-md-4 col-lg-3">
          <label for="colFormLabel" class="col-form-label">VDS Payable</label>
          <v-select
              v-model="formData.vds_payable_account_head_id"
              placeholder="Select VDS Payable"
              class="w-100"
              :options="vdsPayableHeads"
              label="name"
              :reduce="(name) => name.id"
          />
        </div>
        <div class="col-12 col-sm-6 col-md-4 col-lg-3">
          <label for="colFormLabel" class="col-form-label">TDS Payable</label>
          <v-select
              v-model="formData.tds_payable_account_head_id"
              placeholder="Select TDS Payable"
              class="w-100"
              :options="tdsPayableHeads"
              label="name"
              :reduce="(name) => name.id"
          />
        </div>
        <div class="col-12 col-sm-6 col-md-4 col-lg-3">
          <label for="colFormLabel" class="col-form-label">Discount Receipt</label>
          <v-select
              v-model="formData.discount_receipt_head_id"
              placeholder="Select Discount Receipt"
              class="w-100"
              :options="discountAccountHeads"
              label="name"
              :reduce="(name) => name.id"
          />
        </div>
      </div>

      <div class="mt-2"></div>
      <BillPayTable @updateTotal="updateTotalAmount" :payBills="dueBills" />

      <div class="row mt-1">
        <div class="col-12">
          <div class="mb-2">
            <label for="note" class="form-label fw-bold">Memo</label>
            <textarea
              v-model="formData.description"
              placeholder="Memo"
              class="form-control"
              rows="2"
              id="note"
            ></textarea>
          </div>
        </div>
      </div>

      <div class="d-flex gap-1">
        <button
          :disabled="saveButtonLoader"
          @click="payBill(true)"
          class="btn btn-primary"
        >
          <!-- <div v-if="saveButtonLoader" class="spinner-border spinner-border-sm text-light" role="status">
                        <span class="visually-hidden">Loading...</span>
                    </div> -->
          Save
        </button>
        <button
          :disabled="saveButtonLoader"
          @click="payBill(false)"
          class="btn btn-primary"
        >
          <!-- <div v-if="saveButtonLoader" class="spinner-border spinner-border-sm text-light" role="status">
                        <span class="visually-hidden">Loading...</span>
                    </div> -->
          Save & New
        </button>
        <button
          @click="navigateToListPage"
          class="btn btn-outline-secondary cancel-btn"
        >
          Cancel
        </button>
      </div>
    </div>
    <GlobalLoader />
    <ContactDropdownFilter
        v-if="store.state.isModalOpenThree"
        @onSearchContact="onSearchContact"
        type="supplier"
    />
  </div>
</template>

<script setup>
import {ref, onMounted, inject, computed} from "vue";
import { useRouter, useRoute } from "vue-router";
import TitleButton from "@/components/atom/TitleButton";
import BillPayTable from "@/components/molecule/company/inventory/purchase/BillPayTable";
import useBillPayData from "@/data/inventory/billPay.js";
import ContactDropdownFilter from '@/components/atom/Contact/ContactDropdownFilter.vue'
import handlePurchaseAndSales from "@/services/modules/purchase";
import handlePurchase from "@/services/modules/purchase";
import AsyncSelect from "@/components/molecule/input-field/AsyncSelect.vue";
import handleContact from "@/services/modules/contact";
import {useAsyncDropdownHelper} from "@/services/utils/asyncDropdownHelper";

import {useStore} from "vuex";
const { formData, storePayment, storeAdvancePayment, prepareFormData } = handlePurchaseAndSales();
const { getAccountHeadBySlag, fetchAccountPayable } = handlePurchase()
const route = useRoute();
const router = useRouter();
const store = useStore();
const voucherQuery = `?company_id=${route.params.companyId}&voucher_type=payment_voucher&txn_type=bill_payment`;
const {
  getDueList,
  getAccountHead,
  getContactProfiles,
  accountHeads,
  balance,
  dueBills,
  params,
} = useBillPayData(voucherQuery);

const {fetchContactProfiles, fetchSingleContactProfile} = handleContact()
const {formatPatientLabel} = useAsyncDropdownHelper()

const routeContactId = computed(() => route.query.contactId ? route.query.contactId : '')
const singleContactInfo = ref({});
let loader =ref(false)
const saveButtonLoader = ref(false);
const showError = inject("showError");
const showSuccess = inject("showSuccess");
const selectedContact = ref(null);

const vdsPayableHeads = ref([]);
const tdsPayableHeads = ref([]);
const discountAccountHeads = ref([]);

const getAccountPayable = async  () => {
  fetchAccountPayable(`?company_id=${params.companyId}`).then(({status, data}) => {
    if (data.length < 1) {
      return formData.value.account_payable_id = null;
    }

    formData.value.account_payable_id = data[0].id
  })
}

onMounted(async () => {
    const companyQuery = `?company_id=${params.companyId}`;
    if(route.query.contactId) {
      fetchSingleContactProfile(route.query.contactId, companyQuery).then((res) => {
        singleContactInfo.value = res.data;
      }).then(() => {
        onchangeContact(singleContactInfo.value)
      }).catch(e => console.log('Something went wrong'));
    }
    getAccountHead();
    getContactProfiles();
    let data = formData.value;
    data.payment_date = new Date().toISOString().split("T")[0];
    data.company_id = params.companyId;

    const vdsPayableHeadsRes = getAccountHeadBySlag("vds_payable", companyQuery)
    const tdsPayableHeadsRes = getAccountHeadBySlag("tds_payable", companyQuery)
    const discountAccountHeadsRes = getAccountHeadBySlag("discount_receipt", companyQuery)
    Promise.all([
      vdsPayableHeadsRes.then(({data}) => {
        if (data) vdsPayableHeads.value = data
        if (data.length < 1) {
          return formData.value.vds_payable_account_head_id = null;
        }

        formData.value.vds_payable_account_head_id = data[0].id
      }),
      tdsPayableHeadsRes.then(({data}) => {
        if (data) tdsPayableHeads.value = data
        if (data.length < 1) {
          return formData.value.tds_payable_account_head_id = null;
        }

        formData.value.tds_payable_account_head_id = data[0].id
      }),
      discountAccountHeadsRes.then(({data}) => {
        if (data) discountAccountHeads.value = data
        if (data.length < 1) {
          return formData.value.discount_receipt_head_id = null;
        }

        formData.value.discount_receipt_head_id = data[0].id
      }),
      await getAccountPayable()
    ]).then(() => {
      loader.value = false
    }).catch(() => {
      loader.value = false
    })
});
function setRefDate(e) {
  formData.value.payment_reference_date = e.target.value;
}
function navigateToListPage() {
  router.push({ name: "pay-bill-list", params: params, query: route.query });
}

const onOpenContactSearchModal = () => {
  store.state.isModalOpenThree = true;
}

const onSearchContact = (contact) => {
  selectedContact.value = contact;
  getDueList(contact.id);
}

function onchangeContact(e) {
  getDueList(e.id);
}
const totalAmount = ref(0);
const updateTotalAmount = (newTotal) => {
  totalAmount.value = newTotal;
};

function payBill(redirect = false) {
  saveButtonLoader.value = true;
  formData.value.contact_profile_id = routeContactId.value ? routeContactId : selectedContact.value.id;
  formData.value.voucher_type = "payment_voucher";
  formData.value.txn_type = "bill_payment";
  const payload = prepareFormData(dueBills.value, "purchase");

  if (totalAmount.value === 0){
    return storeAdvance(redirect)
  }

  storePayment(payload)
    .then((res) => {
      saveButtonLoader.value = false;
      if (res.status) {
        if (redirect) {
          navigateToListPage();
        } else {
          showSuccess(res.message);
          getDueList(selectedContact.value);
        }
      }
      if (!res.status) {
        showError(res.message);
      }
    })
    .catch((err) => {
      saveButtonLoader.value = false;
    });
}

const storeAdvance = (redirect = false) => {
  storeAdvancePayment({ ...formData.value, date: formData.value.payment_date})
      .then((res) => {
        saveButtonLoader.value = false;
        if (!res.status) {
          showError(res.message);
          return
        }
        showSuccess(res.message);
        if (redirect) {
          navigateToListPage();
        }
      })
      .catch((err) => {
        saveButtonLoader.value = false;
      });
}
</script>
